<template>
    <v-menu
        left
        offset-y
        rounded="0"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                icon
                v-bind="attrs"
                v-on="on"
            >
                <v-icon>mdi-account</v-icon>
            </v-btn>
            <v-btn
                icon
            >
                <v-icon>mdi-bell-badge</v-icon>
            </v-btn>
        </template>
        <!-- User info -->
        <!--v-list-item two-line>
            <v-list-item-content>
                <v-list-item-title>{{ user.name }}</v-list-item-title>
                <v-list-item-subtitle>
                    <a :href="`mailto:${user.email}`">{{ user.email }}</a>
                </v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>

        <v-divider /-->

        <v-list class="list">
            <v-list-item
                v-for="(item, index) in menuItems"
                :key="index"
                link
                dense
                @click="item.action"
                class="list--item"
            >
                <v-list-item-icon>
                    <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
import _ from 'lodash';

export default {
    data() {
        return {
            menuItems: [
                { title: 'Editar Perfil', icon: 'mdi-account-edit', action: this.greet },
                { title: 'Cerrar Sesión', icon: 'mdi-exit-to-app', action: this.logout },
            ]
        }
    },

    methods: {
        showProfile() {
            this.$inertia.get(route('profile.show'));
        },

        greet() {
            console.log('hello');
        },

        logout() {
            this.$inertia.form({}).post(route('logout'));
        },
    },

    computed: {
        user() {
            return _.get(this.$page, 'props.user', {
                name: 'Jane Doe',
                email: 'jane.doe@gmail.com',
            })
        },
    },
}
</script>

<style scoped>
</style>
